angular.module('property-deal')
    .component('propertyDealInfo', {
        bindings: {
            id: '<'
        },
        templateUrl: 'app/property-deal/info.html',
        controller: function (PropertyDealService) {
            this.PropertyDealService = PropertyDealService;
        }
    })
